var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 23.444L30.418 39.844C30.8922 40.1409 31.4405 40.2984 32 40.2984C32.5595 40.2984 33.1078 40.1409 33.582 39.844L60 23.444V23C60 22.7348 59.8946 22.4804 59.7071 22.2929C59.5196 22.1054 59.2652 22 59 22H5C4.73478 22 4.48043 22.1054 4.29289 22.2929C4.10536 22.4804 4 22.7348 4 23V23.444Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 60H59C59.2652 60 59.5196 59.8947 59.7071 59.7072C59.8946 59.5196 60 59.2653 60 59V25.8L34.637 41.541C33.8462 42.0351 32.9325 42.2971 32 42.2971C31.0675 42.2971 30.1538 42.0351 29.363 41.541L4 25.8V59C4 59.2653 4.10536 59.5196 4.29289 59.7072C4.48043 59.8947 4.73478 60 5 60Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterClose);
export default __webpack_public_path__ + "static/media/letterClose.ea2031fb6c6b478e2e6d0255cec80802.svg";
export { ForwardRef as ReactComponent };